import React from 'react'
import styled from 'styled-components'


 
const CARD = styled.section`
    align-items: center;
    justify-content: space-around;
    position: relative;
    background: #020617;
    display: flex;
    border: none;
    box-sizing: border-box;
    border-radius: 20px;
    -webkit-transition: all .5s ease-in-out;
    -webkit-transition: all .5s ease-in-out;
    transition: all .5s ease-in-out;
    font-size: 18px;
    text-align: center;
    padding: .5rem;
    color: white;
    width: 12rem;
    height: 5rem;
    font-size: medium;
     margin-top: 2rem;
    outline: none;
    -webkit-transition: ease-in-out .8s;
    transition: ease-in-out .8s;
    margin-left: 2rem;
    margin-bottom: 7rem;
 
     &:hover {
        box-shadow: 0px 4px 3px 0px #776565;
        transform: translateY(-0.3rem);
        transition: ease-in-out .5s;
    }

    & strong {
        height: calc(100% - 0.5rem);
        width: 3.5rem;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 15px;
        background: #54596fbd;
    }

    article {
        width: auto;
        font-size: 1.35rem;

        h3 {
            color: #949292;
            font-size: small;
        }

        p {
            font-size: medium;
        }
        
    }


`

const DashCards = ({perc, amt, budg, iBg, meR}) => {

    return (
            <>
            <CARD iBg={iBg} meR={meR}>
                <strong> {perc}% </strong>
                <article>

                <h3> {budg} </h3> 
                <p> N {amt.toLocaleString()}  </p>

                </article>

             </CARD>
            </>
    )
}

export default DashCards